export default "__VITE_ASSET__BcFZKcBx__"